import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Outsourced} from "../Outsourced";
import {gsap} from "gsap";
import {
    SimplePresentation, SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {FreeSpinsIntroActionSpins, FreeSpinsRestoreIntro} from "../runnerpresentations/freespin/FreesSpinIntro";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {reelPosition} from "../server/OutsourcedModel";

export class OutsourcedFreespinsIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    public start(flowStateController:FlowStateController) {
        const presentations:SimplePresentation[] = [
            new FreeSpinsRestoreIntro(),
            new FreeSpinsIntroActionSpins(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.doFreespinZeroBet(controller),
                                  ()=>{return true},
                                  "doFreespinZeroBet")
        ];

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "Fs intro runner ");

    }

    private doFreespinZeroBet(controller:SimplePresentationRunnerController) {
        const reels = Outsourced.reelView.reelModels;
        const isQuickStop = Outsourced.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const conveyorSorter = (a:reelPosition, b:reelPosition) => (a.reelID * 4 +  a.reelPosition) - (b.reelID * 4 + b.reelPosition)

        const tl = gsap.timeline();

        if (Outsourced.model.isRestore) {
            tl.add(() => {}, '>0.5');
        }

        tl.add(() => {
            Outsourced.reelView.insertSymbols();
        })
        tl.add(Outsourced.soundPlayer.playSoundBased("respinStart"));

        if (Outsourced.model.data.nextMode == GameMode.FREESPIN) {
            Outsourced.reelView.reelModels.forEach((reel, index) => {
                reel.shouldRespin = true;
                tl.add(Outsourced.reelView.startConveyorBelt(Math.floor(index / 4), index % 4));
                tl.add(() => {Outsourced.reelView.undarkenMultiplier(Math.floor(index / 4), index % 4)});
            });
        } else {
            Outsourced.model.getWinningPositions().sort(conveyorSorter).forEach((pos) => {
                reels[pos.reelID * 4 + pos.reelPosition].shouldRespin = true;
                tl.add(() => {
                    const newMulti = Outsourced.model.data.splitSizes[pos.reelID][pos.reelPosition];
                    Outsourced.reelView.setMultiplierTo(newMulti + 1, pos.reelID, pos.reelPosition);
                })
                tl.add(Outsourced.reelView.startConveyorBelt(pos.reelID, pos.reelPosition, true), isQuickStop ? '<' : '<0.05');
            });
        }



        tl.add(() => {
            Outsourced.apiPlugin.betHandler.zeroBet();
        });

        tl.add(Outsourced.soundPlayer.playLoopBased("respinReelSpinLoop"));
        reels.filter((reel) => reel.shouldRespin).forEach((reel) => {
            tl.add(reel.start(), isQuickStop ? '<' : '<0.05');
        })

        tl.add(() => { controller.finish() }, '>');
    }
}